import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useState } from "react";

interface ConfirmationProps {
  children: React.ReactNode;
  title: string;
  description: string;
  confirm: {
    disabled: boolean;
    label: React.ReactNode;
    onClick: () => Promise<void> | void;
  };
}

export const Confirmation = ({
  title,
  description,
  children,
  confirm,
}: ConfirmationProps) => {
  const [open, setOpen] = useState(false);

  const submit = async () => {
    await confirm.onClick();

    if (!confirm.disabled) {
      setOpen(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            className="flex flex-row gap-2 items-center justify-center"
            onClick={(e) => {
              e.preventDefault();
              submit();
            }}
            disabled={confirm.disabled}
          >
            {confirm.label}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
